import { DragDropModule } from '@angular/cdk/drag-drop';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';

import { MaterialModule } from './material.module';


// Services
import { RedirectGuard } from './providers/redirect-guard';
import { AuthGuard } from './providers/auth.guard';
import { MockDataService } from './providers/mock-data.service';
import { SettingsService } from './providers/settings.service';


// Directives
import { SubmitIfValidDirective } from './directives/submit-if-valid.directive';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { SceneGroupAuthInterceptor } from '../admin/services/scene-group-auth.interceptor';
import { CustomClassDirective } from './directives/custom-class.directive';
import { FluidLayoutService } from './providers/fluid-layout/fluid-layout.service';
import { SearchComponent } from './components/search/search.component';
import { IntersectionObserverDirective } from './directives/intersection-observer.directive';
import { UnderConstructionComponent } from './components/under-construction/under-construction.component';
import { CardVideoComponent } from './components/card-video/card-video.component';
import { FormatImageExtensionPipe } from './pipes/format-image-extension.pipe';
import { CardThumbsUploadComponent } from './components/card-thumbs-upload/card-thumbs-upload.component';
import { UploadProgressComponent } from './components/upload-progress/upload-progress.component';
import { CardHorizontalSliderComponent } from './components/card-horizontal-slider/card-horizontal-slider.component';
import { ThumbnailGalleryComponent } from './components/thumbnail-gallery/thumbnail-gallery.component';
import { LibrarySectionSwitchComponent } from './components/library-section-switch/library-section-switch.component';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { CallbackPipe } from './pipes/callback.pipe';
import { PriceformatPipe } from './pipes/priceformat.pipe';
import { SeeAllSwitchComponent } from './components/see-all-switch/see-all-switch.component';
import { CardCompositeSliderComponent } from './components/card-composite-slider/card-composite-slider.component';
import { SortByDatePipe } from './pipes/sort-by-date.pipe';
import { StopRenderSnackBarComponent } from './stop-render-snack-bar/stop-render-snack-bar.component';
import { SafeUrlPipe } from './pipes/safe-url.pipe';
import { ThumbCompositeComponent } from './components/thumb-composite/thumb-composite.component';
import { CustomBreakPointsProvider } from './providers/custom-breakpoints.provider';
import { FlexLayoutModule, LayoutGapStyleBuilder } from '@angular/flex-layout';
import { CustomLayoutGapStyleBuilder } from './providers/custom-gaps-builder';
import { ResponsiveDirective } from './directives/responsive.directive';
import { FirstUseAdvComponent } from './components/first-use-adv/first-use-adv.component';
import { AuthpopupComponent } from './components/authpopup/authpopup.component';
import { RenderlimitSelectComponent } from './components/renderlimit-select/renderlimit-select.component';
import { PopupIconNotificationComponent } from './components/popup-icon-notification/popup-icon-notification.component';
import { Landing2025Component } from './components/landing2025/landing2025.component';
import { ClassicLandingComponent } from './components/classic-landing/classic-landing.component';
import { ScrollCueComponent } from './components/scroll-cue/scroll-cue.component';
import { DiscoverTopbarComponent } from './components/discover-topbar/discover-topbar.component';
import { SplashScreenComponent } from './components/splash-screen/splash-screen.component';

import { ServiceSettingsComponent } from '../pages/service-settings/service-settings.component';
import { ConfirmationDialogComponent } from './components/dialog/confirmation-dialog.component';
import { Error404Component } from '../pages/error404/error404.component';
import { EncodeUriPipe } from './pipes/encode-uri.pipe';
import { TotalViewsPipe } from './pipes/total-views.pipe';
import { ViewsFormatPipe } from './pipes/views-format.pipe';
import { PosterUrlPipe } from './pipes/poster-url.pipe';
import { JoinMembershipScreenComponent } from './components/join-membership-screen/join-membership-screen.component';
import { ButtonProgressComponent } from './components/button-progress/button-progress.component';
import { CookieConsentComponent } from './components/cookie-consent/cookie-consent.component';
import { UploadProgressPipe } from '../web/pipes/upload-progress.pipe';



@NgModule({
  declarations: [
    SubmitIfValidDirective,
    IntersectionObserverDirective,
    CustomClassDirective,
    ResponsiveDirective,
    SearchComponent,
    UnderConstructionComponent,
    CardVideoComponent,
    FormatImageExtensionPipe,
    CallbackPipe,
    PriceformatPipe,
    SortByDatePipe,
    SafeUrlPipe,
    EncodeUriPipe,
    TotalViewsPipe,
    ViewsFormatPipe,
    PosterUrlPipe,
    UploadProgressPipe,

    // NOT USED NOW
    UploadProgressComponent,

    Error404Component,
    ConfirmationDialogComponent,
    ServiceSettingsComponent,

    CardThumbsUploadComponent,
    CardHorizontalSliderComponent,
    ThumbnailGalleryComponent,
    LibrarySectionSwitchComponent,
    SeeAllSwitchComponent,
    CardCompositeSliderComponent,
    StopRenderSnackBarComponent,
    ThumbCompositeComponent,

    FirstUseAdvComponent,
    AuthpopupComponent,
    RenderlimitSelectComponent,
    PopupIconNotificationComponent,
    Landing2025Component,
    ClassicLandingComponent,
    ScrollCueComponent,
    DiscoverTopbarComponent,
    SplashScreenComponent,
    JoinMembershipScreenComponent,
    ButtonProgressComponent,
    CookieConsentComponent,
  ],
  exports: [
    // Components
    SubmitIfValidDirective,
    IntersectionObserverDirective,
    CustomClassDirective,
    ResponsiveDirective,
    SearchComponent,
    UnderConstructionComponent,
    CardVideoComponent,
    CardThumbsUploadComponent,
    UploadProgressComponent,
    CardHorizontalSliderComponent,
    ThumbnailGalleryComponent,
    LibrarySectionSwitchComponent,
    SeeAllSwitchComponent,
    CardCompositeSliderComponent,
    StopRenderSnackBarComponent,
    ThumbCompositeComponent,

    FirstUseAdvComponent,
    RenderlimitSelectComponent,
    PopupIconNotificationComponent,
    SplashScreenComponent,
    Landing2025Component,
    ClassicLandingComponent,
    ScrollCueComponent,
    DiscoverTopbarComponent,
    JoinMembershipScreenComponent,
    ButtonProgressComponent,
    CookieConsentComponent,

    FormatImageExtensionPipe,
    CallbackPipe,
    PriceformatPipe,
    SortByDatePipe,
    SafeUrlPipe,
    EncodeUriPipe,
    TotalViewsPipe,
    ViewsFormatPipe,
    PosterUrlPipe,
    UploadProgressPipe,

    // Modules
    ReactiveFormsModule,
    BrowserAnimationsModule,
    MaterialModule,
    FlexLayoutModule,
    FormsModule,
    DragDropModule,
    ScrollingModule,
  ],
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    MaterialModule,
    FlexLayoutModule,
    FormsModule,
    HttpClientModule,
    DragDropModule,
    ScrollingModule,

  ],
  providers: [
    RedirectGuard,
    AuthGuard,
    FluidLayoutService,
    MockDataService,
    SettingsService,
    CustomBreakPointsProvider,
    { provide: LayoutGapStyleBuilder, useClass: CustomLayoutGapStyleBuilder },
    // Registered here (eager root) rather than in the lazy AdminModule so it
    // actually applies to the root HttpClient. Host-filtered, so it no-ops for
    // every non-admin request. Attaches the Firebase Bearer token to spanner
    // admin/content endpoints (same principle as cards.service.ts).
    { provide: HTTP_INTERCEPTORS, useClass: SceneGroupAuthInterceptor, multi: true },
  ],
})
export class SharedModule { }
